import { useState, useEffect } from 'react'

import { Tooltip, TOOLTIP_TYPE } from '../common/tooltip/tooltip'
import { TooltipContextProvider, useTooltipDisplayContext } from '../common/tooltip/tooltip.context'
import { LineChart } from '../../charts/line/line-chart'
import { lineFormatService } from './line-format.service'
import { lineChartService } from '../../charts/line/line-chart.service'

export const LineChartWithTooltip = function ({
  selectedX: selectedXProp,
  tooltipCoordinates: tooltipCoordinatesProp,
  onTooltipChange,
  ...props
}) {
  const [selectedX, setSelectedX] = useState()
  let [tooltipCoordinates, setTooltipCoordinates] = useState()

  const [closestPoints, setClosestPoints] = useState()

  const tooltipProps = {
    closestPoints,
    series: props.series,
    primaryValueFormat: props.yFormat,
    secondaryValueFormat: props.y2Format,
    ciFormat: props.yCIFormat,
    missingPointDisplay: props.missingPointDisplay
  }

  function handleMouseMove (_, eventLocations) {
    const selectedX = eventLocations?.closestCurrentPoint?.x
    setSelectedX(selectedX)

    const x = eventLocations?.xPixelExact
    const y = eventLocations?.yPixelExact
    const coords = (x !== undefined && y !== undefined) ? [x, y] : undefined
    setTooltipCoordinates(coords)

    if (eventLocations.closestPoints) {
      setClosestPoints(eventLocations.closestPoints)
    }

    if (onTooltipChange) {
      onTooltipChange(coords, selectedX)
    }
  }

  function handleMouseLeave () {
    setTooltipCoordinates()
    setClosestPoints()
    setSelectedX()

    if (onTooltipChange) {
      onTooltipChange()
    }
  }

  return (
    <TooltipContextProvider>
      <LineChart
        selectedX={selectedX ?? selectedXProp}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        {...props}
      />
      <LineTooltip
        type={TOOLTIP_TYPE.LIST}
        selectedX={selectedX ?? selectedXProp}
        tooltipCoordinates={tooltipCoordinates ?? tooltipCoordinatesProp}
        {...tooltipProps}
      />
    </TooltipContextProvider>
  )
}

function LineTooltip ({
  selectedX,
  tooltipCoordinates,
  closestPoints: closestPointsProp,
  series,
  primaryValueFormat,
  secondaryValueFormat,
  ciFormat,
  missingPointDisplay
}) {
  const [, setTooltipDisplayData] = useTooltipDisplayContext()

  useEffect(() => {
    if (!tooltipCoordinates) {
      setTooltipDisplayData()
      return
    }

    let closestPoints = closestPointsProp
    if (!closestPoints) {
      const result = lineChartService.findClosestPoints(series, selectedX)
      closestPoints = result?.closestPoints
    }

    if (!closestPoints) {
      setTooltipDisplayData()
    }

    const tooltipDisplayData = lineFormatService.formatDataForTooltip({
      closestPoints,
      series,
      primaryValueFormat,
      secondaryValueFormat,
      ciFormat,
      missingPointDisplay
    })
    setTooltipDisplayData({ list: tooltipDisplayData })
  }, [
    selectedX,
    tooltipCoordinates,
    closestPointsProp,
    series,
    primaryValueFormat,
    secondaryValueFormat,
    ciFormat,
    missingPointDisplay,
    setTooltipDisplayData
  ])

  return (
    <Tooltip
      type={TOOLTIP_TYPE.LIST}
      tooltipCoordinates={tooltipCoordinates}
    />
  )
}
